export default "__VITE_ASSET__099c84a7__"